<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <h1 class="title is-3">Friend galleries:</h1>
      </div>
    </div>
    <!--<div class="colums">
      <FolderDropzone />
    </div>-->
    <div class="columns is-multiline">
      <div class="column is-3" v-for="gallery in friendGalleries" :key="gallery.id">
        <router-link v-bind:to="'/galleries/' + gallery.id">
          <GalleryPreview v-bind:gallery="gallery" />
        </router-link>
      </div>
    </div>
  </div>
</template>
{{ friend.name }}
<script>
import GalleryPreview from "../components/GalleryPreview.vue";
import { mapState, mapActions } from "vuex";

export default {
  computed: mapState(["friendGalleries"]),
  components: {
    GalleryPreview,
  },
  created() {
    this.friendId = parseInt(this.$route.params.id);
    this.getFriendGalleries(this.friendId);
  },
  methods: {
    ...mapActions(["getFriendGalleries"])
  }
};
</script>
